import React from 'react';
import PropTypes from 'prop-types';
import { ButtonWithIcon } from '@els/els-react--button';
import { MetadataPropTypesShape } from '@Components/Results/MetadataPropTypes';
import SubstanceReaxysInformation from '@Components/Results/substances/information/substance-reaxys-information.component';
import './substance-information.component.scss';

export default class SubstanceInformation extends React.PureComponent {
  render() {
    const { metadata, substance, database, onToggle, toggleFact, facts, zoom } = this.props;
    const { index: substanceIndex, details } = substance;

    return (
      <div id={`substances-alldata-${substanceIndex}`} className="substance-results-information typography-small" aria-expanded>
        <div className="sub-menu">
          <ButtonWithIcon
            type="link"
            iconOnly
            sprite="Close"
            className="sub-menu-close-button"
            data-automationId="sub-menu-close"
            onClick={onToggle}>
            close
          </ButtonWithIcon>
          <SubstanceReaxysInformation
            metadata={metadata}
            facts={facts}
            toggle={toggleFact}
            details={details}
            database={database}
            substanceIndex={substanceIndex}
            zoom={zoom}
            substance={substance}
          />
        </div>
      </div>
    );
  }
}

SubstanceInformation.propTypes = {
  metadata: MetadataPropTypesShape,
  substance: PropTypes.object.isRequired,
  database: PropTypes.object.isRequired,
  onToggle: PropTypes.func.isRequired,
  facts: PropTypes.object.isRequired,
  toggleFact: PropTypes.func.isRequired,
  zoom: PropTypes.number,
};
